import { render, staticRenderFns } from "./FulfillmentDelivery.vue?vue&type=template&id=210134a6&scoped=true"
import script from "./FulfillmentDelivery.vue?vue&type=script&lang=js"
export * from "./FulfillmentDelivery.vue?vue&type=script&lang=js"
import style0 from "./FulfillmentDelivery.vue?vue&type=style&index=0&id=210134a6&prod&lang=scss&scoped=true"
import style1 from "./FulfillmentDelivery.vue?vue&type=style&index=1&id=210134a6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "210134a6",
  null
  
)

export default component.exports